import { api } from "./api";

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return data;
};
